import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'detail-view-item',
  templateUrl: './detail-view-item.component.html',
  styleUrls: ['./detail-view-item.component.scss'],
})
export class DetailViewItemComponent implements OnInit {
  @Input() public label: string;
  @Input() public data: string;
  @Input() public color: string;

  constructor() { }

  ngOnInit() {    
    
  }

}
